import React from "react";
import { useDimensions } from "../../Util";
import ContentWithLineLimit from "../../UtilComps/ContentWithLineLimit";
import { useNavigate } from "react-router-dom";

const TimeContainer = ({ clockBalance, punishmentOwe }) => {

    const { w, h } = useDimensions();
    const navigate = useNavigate();

    const timeContainer = {
        gridRow: w > h ? "1 / 17" : "13/20",
        gridColumn: w > h ? "28 / 38" : "30/51",
        background: w > h ? "#00ADB5" : "#393E46",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    }

    const content = {
        width: "80%",
        height: "70%",
        borderRadius: w > h ? 3 * w : 2 * h,
        background: "#393E46",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: w > h ? "center" : "space-between",
        alignItems: "center"
    }

    const heading = {
        width: "100%",
        height: "20%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "3px"
    }

    const imageStyle = {
        height: w > h ? 7 * h : 5.5 * h,
        width: w > h ? 7 * h : 5.5 * h
    }

    const youOwe = {
        fontSize: w > h ? "clamp(12px,2vw,15px)" : "clamp(12px,1vh,15px)",
        color: w > h ? "#EEEEEE" : "#EEEEEE",
        fontWeight:300,
        fontFamily: "Outfit",
        marginTop:w>h?"-10px":"0px",
        cursor:"pointer"
    }

    const handleClick=()=>{
        navigate("/alternates",{state:{origin:"youowe"}})
    }



    return <div id="time-container-frame" style={timeContainer}>
        <div id="heading" style={heading}>
            <div style={{ background: w > h ? "" : "#00ADB5", paddingInline: w > h ? "0px" : "10px", width:"100%",textAlign:w>h?"center":"start"}}>
                <ContentWithLineLimit
                    fontColor={"#EEEEEE"}
                    Fontsref={w > h ? "addiction-card-text-bold-desktop" : "tiny-font-mobile"}
                    content={"PUNISHMENT CLOCK"}
                    lineLimit={1}
                ></ContentWithLineLimit>
            </div>
        </div>
        <p style={youOwe} onClick={handleClick}>You Owe {punishmentOwe}m</p>
        <div id="content" style={content}>
            <img src={`/images/time2.png`} style={imageStyle} alt="Description" />
            <div style={{ background: w > h ? "" : "#00ADB5", padding: w > h ? "0px" : "7px" }}>
                <ContentWithLineLimit
                    fontColor={"#EEEEEE"}
                    Fontsref={w > h ? "penalty-text-desktop" : "penalty-text-mobile"}
                    content={clockBalance > -1 ? clockBalance + "m" : "m"}
                    lineLimit={1}
                ></ContentWithLineLimit>
            </div>
        </div>
    </div>
}

export default TimeContainer;